enum PendingListCardVariant {
  DECISION = 'decision',
  NEGOTIATION = 'negotiation'
}

export default PendingListCardVariant;
